import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import { ButtonPrimary } from "src/UI/ButtonPrimary";

export interface AlertDialogCstProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  closeLabel: string;
  onClose: () => void;
}

const AlertDialogCst: React.FC<AlertDialogCstProps> = ({
  open,
  title,
  description,
  closeLabel,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.border}`,
        },
      }}
    >
      <DialogTitle
        sx={{ padding: "20px 24px 8px", color: theme.palette.text.primary }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ padding: "8px 24px 16px" }}>
        {typeof description === "string" ? (
          <Typography
            sx={{
              fontSize: "14px",
              color: theme.palette.text.primary,
              lineHeight: 1.5,
            }}
          >
            {description}
          </Typography>
        ) : (
          description
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "8px 24px 20px" }}>
        <ButtonPrimary size="md" onClick={onClose}>
          {closeLabel}
        </ButtonPrimary>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialogCst;
